import { render, staticRenderFns } from "./MyQuotes.vue?vue&type=template&id=39af7c02&scoped=true&"
import script from "./MyQuotes.vue?vue&type=script&lang=js&"
export * from "./MyQuotes.vue?vue&type=script&lang=js&"
import style0 from "./MyQuotes.vue?vue&type=style&index=0&id=39af7c02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39af7c02",
  null
  
)

export default component.exports